// Utility functions for handling redirects after authentication

const REDIRECT_KEY = 'auth_redirect_path';

/**
 * Save the current path to redirect to after login
 */
export const saveRedirectPath = (path: string) => {
  console.log('Saving redirect path:', path);

  // Don't save auth-related paths
  if (
    path.startsWith('/login') ||
    path.startsWith('/register') ||
    path.startsWith('/forgot-password') ||
    path.startsWith('/auth/')
  ) {
    console.log('Not saving auth-related path:', path);
    return;
  }

  // Don't save the root path if it's just "/"
  if (path === '/') {
    console.log('Not saving root path');
    return;
  }

  sessionStorage.setItem(REDIRECT_KEY, path);
  console.log('Saved redirect path:', path);
};

/**
 * Get the saved redirect path and clear it
 */
export const getAndClearRedirectPath = (): string | null => {
  const redirectPath = sessionStorage.getItem(REDIRECT_KEY);
  console.log('Getting redirect path:', redirectPath);
  if (redirectPath) {
    sessionStorage.removeItem(REDIRECT_KEY);
    console.log('Cleared redirect path, returning:', redirectPath);
    return redirectPath;
  }
  console.log('No redirect path found');
  return null;
};

/**
 * Clear any saved redirect path
 */
export const clearRedirectPath = () => {
  console.log('Clearing redirect path manually');
  sessionStorage.removeItem(REDIRECT_KEY);
};

/**
 * Check if there's a saved redirect path
 */
export const hasRedirectPath = (): boolean => {
  return sessionStorage.getItem(REDIRECT_KEY) !== null;
};
